import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/EY-quiz-illustration.svg'


const _withScopeId = n => (_pushScopeId("data-v-dc21a6c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  draggable: "false"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, [
  /*#__PURE__*/_createTextVNode(" Hodíme"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" se k sobě? ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Jen "),
    /*#__PURE__*/_createElementVNode("strong", null, "10 otázek"),
    /*#__PURE__*/_createTextVNode(" tě dělí od objevení toho pro tebe nejvhodnějšího oddělení v EY. ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Jsem něco mezi Tinderem a moudrým kloboukem z Harry Pottera. 10x swajpneš a přiřadím tě do té "),
    /*#__PURE__*/_createElementVNode("strong", null, "správné EY koleje.")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/gdpr.pdf",
    target: "_blank",
    class: "gdpr"
  }, "Souhlas se zpracováním osobních údajů")
], -1))

import { ref } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'WelcomeScreen',
  setup(__props) {

const store = useStore();

const isActive = ref(true);

const start = () => {
  store.commit("start");
  isActive.value = false;
};

return (_ctx: any,_cache: any) => {
  return (isActive.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", { class: "info" }, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("button", {
            class: "button solidButton",
            onClick: start
          }, "Pojďme začít!"),
          _hoisted_5
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})